module.exports = ".avatar { float: right; margin-left: 15px; width: 30px; height: 30px; border-radius: 50%; }\n\n.avatar-null { width: 30px !important; height: 30px !important; border-radius: 50%;  padding: 3px; color: #888; background: #eee; float: right; }"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/list-technical/list-technical.component.css
// module id = ./src/app/shared/list-technical/list-technical.component.css
// module chunks = main